import React, { Component } from 'react'
import moment from "moment";
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createMagazine,
  updateMagazine,
  getMagazine,
  deleteMagazine } from '../../../services/MagazineService'

import {
        getIssueListByMagazineId } from '../../../services/IssueService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class MagazinePageView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      magazineId: null,
      magazine: null,

      issueList: []
    };

    this.goBack = this.goBack.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  goBack(){
      this.props.history.goBack();
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    log.debug(this.props.match.params)
    // load info
    let magazine = await getMagazine(this.props.match.params.id)
    log.debug(magazine)

    let issueList = await getIssueListByMagazineId(this.props.match.params.id);
    this.setState({issueList: issueList})

    log.debug('all data is loaded.')
    this.setState({magazineId: this.props.match.params.id})
    this.setState({magazine: magazine})
    this.setState({isLoading: false})
  }

  async handleDelete(magazineId, e) {
    e.preventDefault()
    log.debug(magazineId)
    var r = window.confirm("Confirm to delete.");
    if (r == true) {
        log.debug('do delete')
        try{
          await deleteMagazine(magazineId)
          log.debug('delete success.')

          this.state.magazine.status = 'D'
          this.setState({magazine: this.state.magazine})
        }catch(err){
          log.debug(err)
          this.setState(setErrorMsg(err))
        }

    } else {
        log.debug('delete cancel')
    }
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <button className="btn btn-success" onClick={this.goBack}>Go Back</button> -> {this.state.magazine.title}
        </h4>
        <div className="panel panel-default">
    <div className="panel-heading">
        <Link className="btn btn-success" to={`/magazine/edit/${this.state.magazineId}`}>Edit</Link>
        &nbsp;
        <button
          type="button"
          onClick={(e) => this.handleDelete(this.state.magazineId, e)}
          className="btn btn-small btn-danger">Delete</button>
          <br/> <br/>
        <Link className="btn btn-success" to={`/issue/add/${this.state.magazineId}?magazine_uuid=${this.state.magazine.magazine_uuid}`}>Add New Issue</Link>
    </div>
    {/* /.panel-heading */}
    <div className="panel-body">
        <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th style={{width: '20%'}}>Name</th>
                        <th>value</th>
                    </tr>
                </thead>
                <tbody>
                  <tr>
                      <td>magazine_id</td>
                      <td>{this.state.magazineId}</td>
                  </tr>

                    <tr>
                        <td>magazine_uuid</td>
                        <td>{this.state.magazine.magazine_uuid}</td>
                    </tr>

                    <tr>
                        <td>publisher_id</td>
                        <td>{this.state.magazine.publisher_id}</td>
                    </tr>

                    <tr>
                        <td>owner_id</td>
                        <td>{this.state.magazine.owner_id}</td>
                    </tr>

                    <tr>
                        <td>tag</td>
                        <td>{this.state.magazine.tag}</td>
                    </tr>

                    <tr>
                        <td>title</td>
                        <td>{this.state.magazine.title}</td>
                    </tr>

                    <tr>
                        <td>description</td>
                        <td>{this.state.magazine.description}</td>
                    </tr>

                    <tr>
                        <td>latest_issue_id</td>
                        <td>{this.state.magazine.latest_issue_id}</td>
                    </tr>

                    <tr>
                        <td>is_publish</td>
                        <td>{this.state.magazine.is_publish}</td>
                    </tr>

                    <tr>
                        <td>sort_order</td>
                        <td>{this.state.magazine.sort_order}</td>
                    </tr>

                    <tr>
                        <td>share_text</td>
                        <td>{this.state.magazine.share_text}</td>
                    </tr>

                    <tr>
                        <td>embed_html</td>
                        <td>{this.state.magazine.embed_html}</td>
                    </tr>

                    <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.magazine.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr>

                    <tr>
                        <td>status</td>
                        <td>{this.state.magazine.status}</td>
                    </tr>


                    {/* <tr>
                        <td>date_created</td>
                        <td>{moment(this.state.magazine.date_created).format('DD/MM/YYYY, h:mm:ss')}</td>
                    </tr> */}

                </tbody>
            </table>
        </div>
        {/* /.table-responsive */}
    </div>
    {/* /.panel-body */}
</div>

<div>
    <h4 className="page-header">
    Issue List
  </h4>
    <table className="table">
        <thead>
            <tr>
                <th> issue_id </th>

                {/* <th>issue_uuid</th>  */}
                <th>magazine_id</th>
                {/* <th>owner_id</th>  */}
                <th>tag</th>
                <th>title</th>
                {/* <th>description</th>  */}
                <th>is_publish</th>
                {/* <th>issue_version</th>
                <th>cover_width</th>
                <th>cover_height</th>
                <th>cover_url</th>
                <th>issue_download_url</th>
                <th>download_success_msg_title</th>
                <th>download_success_msg_body</th>
                <th>notify_cover_number</th>
                <th>share_text</th>
                <th>embed_html</th>  */}
                {/* <th>date_released</th>
                <th>date_modified</th>  */}
                <th>date_created</th>
                <th>status</th>
                <th> Actions </th>
            </tr>
        </thead>
        <tbody>
          {
            this.state.issueList.map((data, index) =>
            <tr key={index}>
              <td>{data.id}</td>

                {/* <td>{data.data().issue_uuid} </td>  */}
                <td>{data.data().magazine_id} </td>
                {/* <td>{data.data().owner_id} </td>  */}
                <td>{data.data().tag} </td>
                <td>{data.data().title} </td>
                {/* <td>{data.data().description} </td>  */}
                <td>{data.data().is_publish} </td>
                {/* <td>{data.data().issue_version} </td>
                <td>{data.data().cover_width} </td>
                <td>{data.data().cover_height} </td>
                <td>{data.data().cover_url} </td>
                <td>{data.data().issue_download_url} </td>
                <td>{data.data().download_success_msg_title} </td>
                <td>{data.data().download_success_msg_body} </td>
                <td>{data.data().notify_cover_number} </td>
                <td>{data.data().share_text} </td>
                <td>{data.data().embed_html} </td>  */}
                {/* <td>{data.data().date_released} </td>
                <td>{data.data().date_modified} </td>  */}
                <td>{moment(data.data().date_created).fromNow()}</td>
                <td>{data.data().status} </td>
              {/* <td>{moment(data.data().date_created).fromNow()}</td> */}
              <td>
                <Link className="btn btn-small btn-primary" to={`/issue/view/${data.id}`}>view</Link>
              </td>
            </tr>
          )
          }
        </tbody>
    </table>
</div>


      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/MagazinePage/MagazinePageView.js